import { reportWorkerError } from '$$workerErrorReporting';

// WORKER_IMPORTSCRIPTS_LOAD_FAILED (BugSnag 69b2d444e8d635433d668145):
// Worker is created here immediately; importScripts in *_worker.js starts before
// onerror below is attached, so boot-time NetworkError / NS_BINDING_ABORTED are unhandled.
// How to fix:
// - create Worker lazily on first call (and in *Worker.js singletons: not in constructor)
// - attach onerror at creation time; on failure terminate + recreate
// - reportWorkerError: notifyErrorSafely + reject — do not throw (unreachable reject below)

function sourceFromPath(path) {
  const match = path.match(/\/([^/]+)\.js/);

  return match ? match[1] : 'worker';
}

export default function (workerPath) {
  const worker = new Worker(workerPath);
  const source = sourceFromPath(workerPath);

  return function (workerData) {
    return new Promise((resolve, reject) => {
      worker.onmessage = function (e) {
        worker.onmessage = null;
        worker.onerror = null;

        return resolve(e.data);
      };

      worker.onerror = function (e) {
        worker.onmessage = null;
        worker.onerror = null;
        reportWorkerError(e, source);
        const message = e.message || `${e.filename || 'worker'}:${e.lineno || 0}`;
        const err = new Error(message);
        const filename = e.filename || 'worker';
        const lineno = e.lineno || 0;
        const colno = e.colno != null ? e.colno : 0;
        err.stack = `Error: ${message}\n    at onmessage (${filename}:${lineno}:${colno})`;
        reject(err);
      };

      worker.postMessage(workerData);
    });
  };
}
